"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var faInfoCircle_1 = require("@fortawesome/pro-light-svg-icons/faInfoCircle");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var material_1 = require("@mui/material");
var Tooltip_1 = __importDefault(require("atomicComponents/atoms/Tooltip"));
var Text_1 = __importDefault(require("shared/components/Text"));
var SaasOverspendPopup = function () { return ((0, jsx_runtime_1.jsx)(Tooltip_1.default, __assign({ title: ((0, jsx_runtime_1.jsx)(material_1.Box, __assign({ p: 1 }, { children: (0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: 2 }, { children: ["Are you paying the most ", (0, jsx_runtime_1.jsx)("strong", { children: "optimal price" }), " for your SaaS Stack?"] })) }))), placement: "left" }, { children: (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ component: "span", ml: 1, sx: { cursor: 'pointer' } }, { children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: faInfoCircle_1.faInfoCircle, size: "xs", color: "grey" }) })) }))); };
exports.default = SaasOverspendPopup;
